import React, { useMemo } from 'react';

import useMergeProps from '../../../../hooks/useMergeProps';
import useTypedSelector from '../../../../hooks/useTypedSelector';
import { useLineUpMainViewContext } from '../../contexts/LineUpMainViewContext';

import LineUpRacer from './LineUpRacer';
import makeLineUpRacerPropsSelector from './LineUpRacer.selector';

type PropsType = {
  className?: string;
  competitorId: number;
  position: number;
};

const LineUpRacerContainer = (ownProps: PropsType) => {
  const { competitorId } = ownProps;

  const { sportId } = useLineUpMainViewContext();

  const selectorProps = useMemo(() => ({ competitorId }), [competitorId]);
  const selector = useMemo(() => makeLineUpRacerPropsSelector(), []);
  const selectedProps = useTypedSelector((state) => selector(state, selectorProps));

  const otherProps = useMemo(
    () => ({
      sportId,
    }),
    [sportId],
  );

  const enhancedProps = useMergeProps({ ownProps: { ...ownProps, competitorId }, selectedProps, otherProps });

  return <LineUpRacer {...enhancedProps} />;
};

export default LineUpRacerContainer;
